<template>
  <div class="website-connexion">
    <violet-bar>Paramètres de connexion au site web</violet-bar>
    <div class="squarebox">
      <div class="field">
        <label for="" class="label">URL du Webhook :</label>
        <input type="text" class="input" v-model="form.url" />
      </div>

      <div class="field">
        <label for="" class="label">Token d'accès :</label>
        <input type="text" class="input" v-model="form.token" />
      </div>

      <div class="buttons">
        <button class="button is-primary" @click="save">
          Enregistrer ces réglages
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import VioletBar from "../Projects/VioletBar";
import { types } from "../../store/actions/misc";
import { silence } from "../../util/func";

export default {
  name: "website_connection",
  components: { VioletBar },
  data() {
    return {
      form: {
        url: "",
        token: ""
      }
    };
  },
  methods: {
    async fetch() {
      try {
        const { url, token } = await this.$store.dispatch(
          types.GET_WEBHOOK_PARAMS
        );
        this.form.url = url;
        this.form.token = token;
      } catch (e) {
        silence(e);
      }
    },
    save() {
      this.$store.dispatch(types.SET_WEBHOOK_PARAMS, this.form);
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>
